<template>
    <div>
        <mu-badge :content="notifications.length + ''" circle color="secondary">
            <mu-button small icon :style="{marginLeft:mu_button_margin_left, color:mu_button_color}" @click="openNotificationsList" :title="$t('notification.title')">
                <mu-icon value="notifications" :size="mu_icon_size"></mu-icon>
            </mu-button>
        </mu-badge>

        <el-dialog :modal-append-to-body="el_modal_dialog_append_to_body" :append-to-body="el_dialog_append_to_body" :modal="true" :title="$t('notification.title')" :visible.sync="listVisible"
            width="50%" @close="closeNotificationsList">
            <div v-if="notifications.length > 0">
                <div v-for="item in notifications" :key="item.id" style="margin-left: 20px; margin-right: 20px;">
                    <div style="display: flex;justify-content: space-between; align-items: flex-end;">
                        <span>{{ item.content }}</span>
                        <div style="width: 200px; display: flex; align-items: center; justify-content: space-between;">
                            <span>{{ new Date(item.createTime).toLocaleString() }}</span>
                            <el-button type="text" size="small" @click="() => clean(item.id)">{{ $t('button.clear')
                            }}</el-button>
                        </div>

                    </div>
                    <el-divider></el-divider>
                </div>
            </div>
            <div v-else>
                <el-empty></el-empty>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeNotificationsList">{{ $t('button.shutDown') }}</el-button>
                <el-button size="small" :disabled="notifications.length==0" type="primary" :loading="cleaning" @click="cleanNotifications">{{
                    $t('button.cleanAll') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { get, delet } from "../../axios";
import store from '@/vuex/store'

export default {
    props: {
        mu_button_color: {
            type: String,
            default: 'grey'
        },
        mu_button_margin_left: {
            type: String,
            default: '32px'
        },
        mu_icon_size: {
            type: String,
            default: '24'
        },
        el_modal_dialog_append_to_body: {
            type: Boolean,
            default: false
        },
        el_dialog_append_to_body: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            notifications: [],
            listVisible: false,
            cleaning: false
        }
    },

    async created() {
        await this.$onWait;
        this.loadNotifications();
    },

    methods: {

        openNotificationsList() {
            this.listVisible = true;
        },

        closeNotificationsList() {
            this.listVisible = false;
        },

        async loadNotifications() {
            let res = await get("notification/list", {
                userId: store.state.user.id
            })
            this.notifications = res
        },

        async cleanNotifications() {
            try {
                this.cleaning = true
                await delet("notification", this.notifications.map(n => n.id))
                await this.loadNotifications()
            } catch (error) {
                console.log(error);
            } finally {
                this.cleaning = false
            }
        },

        async clean(id) {
            try {
                this.notifications = []
                await delet("notification", [id])
                await this.loadNotifications()
            } catch (error) {
                console.log(error);
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/notifications/index.vue